export default {
    buttons: {
        cart: {
            add: "Add",
            remove: "Remove From Cart"
        }
    },
    added: "Added to Cart",
    description: "Description"
}